import { graphql } from 'gatsby'
import * as PropTypes from 'prop-types'
import React from 'react'
import Fade from 'react-reveal/Fade';
import Masonry from 'react-masonry-css'
import { connect } from 'react-redux'

import { SectionTitle, SectionUptitle } from '../../components'
import SeoModel from '../../datas/models/Seo'
import asTemplate from '../../root/Template'
import { getContentfulField, withTransformer } from '../../utils/GatsbyUtils'
import { chainDecorators, memoized } from '../../utils/ReactUtils'
import Seo from '../../components/Seo'
import { getTranslationFunction } from '../../utils/TranslationUtils'
import HomeContact from '../Homepage/HomeContact'

import styles from './styles'
import GatsbyImage from 'gatsby-image'


const COLOR_SEED = 56080331684335

const mapSelectors = () => ({
  //
})

const mapActions = dispatch => ({
  //
})

const transformer = (data) => {
  const { contentfulStudioTemplate, contentfulLocale } = data

  if (contentfulStudioTemplate && contentfulLocale) {
    return {
      studioPageData: {
        advertisers: getContentfulField(contentfulStudioTemplate, 'advertisersDescription'),
        agencies: getContentfulField(contentfulStudioTemplate, 'agenciesDescription'),
        startups: getContentfulField(contentfulStudioTemplate, 'startupsDescription'),
        method: getContentfulField(contentfulStudioTemplate, 'ourMethod'),
        team: getContentfulField(contentfulStudioTemplate, 'teamDescription'),
        pictures: contentfulStudioTemplate.pictures,
        seo: SeoModel(contentfulStudioTemplate.seo),
        tags: getContentfulField(contentfulStudioTemplate, 'tags'),
      },
      t: getTranslationFunction(contentfulLocale.texts),
    }
  }
}

const decorators = [
  asTemplate,
  withTransformer(transformer),
  connect(mapSelectors, mapActions),
  memoized,
]

function StudioTemplate(props) {
  const { studioPageData, t } = props

  console.log('studioPageData', studioPageData)

  return (
    <>
      <Seo {...studioPageData.seo} />
      <section className="method">
        <article>
          <SectionTitle
            normalTitle={t('agencyTitle')}
          />
          <div>
            <p>{studioPageData.method}</p>
            {studioPageData.tags
        && studioPageData.tags.map(tag => (
          <p
            className="tag-content"
            key={tag}
          >
            {tag}
          </p>
        ))
      }
          </div>
        </article>
        <article className='team-article'>
          <div className="team-box">
            <SectionUptitle
              title={t('theTeam')}
            />
            <p>{studioPageData.team}</p>
          </div>
        </article>
      </section>

      <section className="team">
        <div
          className="pictures"
        >
          <Masonry
            breakpointCols={{ default: 2, 700: 1 }}
            className="masonry-grid"
            columnClassName="masonry-grid_column">
            {studioPageData.pictures.map((picture, i) => (
              <Fade key={`picture-${i}`}>
                <GatsbyImage {...picture} />
              </Fade>
            ))}
          </Masonry>
        </div>
      </section>
      <HomeContact
        title={t('haveAnIdea')}
        contactEmail={t('contactEmail')}
      />
      <style jsx>{styles}</style>
    </>
  )
}

StudioTemplate.propTypes = {
  studioPageData: PropTypes.shape({
    advertisers: PropTypes.string,
    agencies: PropTypes.string,
    startups: PropTypes.string,
    method: PropTypes.string,
    team: PropTypes.string,
    pictures: PropTypes.array,
    seo: SeoModel.propTypes,
    translations: PropTypes.objectOf(PropTypes.string),
    tags: PropTypes.arrayOf(
      PropTypes.string
    ),
  }),
}

StudioTemplate.defaultProps = {
  studioPageData: {
    advertisers: '',
    agencies: '',
    startups: '',
    method: '',
    team: '',
    pictures: [],
    seo: SeoModel.defaultProps,
    translations: {},
    tags: [],
  },
}

StudioTemplate = chainDecorators(decorators, StudioTemplate)

export default StudioTemplate

export const query = graphql`
  query($langKey: String!) {
    contentfulStudioTemplate(node_locale: { eq: $langKey }) {
      ...bbsContentfulStudio
    }
    allContentfulDomain(filter: { node_locale: { eq: $langKey } }) {
      edges {
        node {
          ...bbsContentfulDomain
        }
      }
    }
    contentfulLocale (node_locale: {eq: $langKey}){
      texts {
        agencyTitle
        clientAgencyTitle
        clientBrandTitle
        clientStartupTitle
        ourClients
        ourMethod
        theTeam
        haveAnIdea
      }
    }
  }
`
